import {Draggable} from "react-beautiful-dnd";
import {Icon, IconButton, makeStyles} from "@material-ui/core";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../Utils/lib";
import React from "react";
const useStyles = makeStyles(() => ({
    questionContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'rgba(0,0,0,0.02)',
        width: '100%',
        padding: 10,
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        '&:hover': {
            '& $actionsContainer': {
                visibility: 'visible'
            },
            '& $removeButtonContainer': {
                visibility: 'visible'
            }
        }
    },
    removeButtonContainer: {
        display: "flex",
        visibility: 'hidden'
    }
}))
const QuestionItem = ({question, index,dataSource, setQuestionModalState, removeGroup}) => {
    const classes = useStyles()
    const userLanguage = useSelector(state => state.app.userLanguage);

    return(
        <Draggable draggableId={"question_" + index} index={index} key={index}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={classes.questionContainer}

                >
                    <div style={{width: '33.3%'}}>
                        {question.type}
                    </div>
                    <div style={{width: '33.3%'}}>
                        {multiLanguageValue(question.label, userLanguage)}
                    </div>
                    <div style={{width: '33.3%'}}>
                        {question.weight}
                    </div>
                    <div className={classes.removeButtonContainer}>
                        <IconButton size={'small'} onClick={() => {
                           removeGroup(dataSource + '.questions.' + index)
                        }}>
                            <Icon fontSize={"small"}>
                                highlight_off
                            </Icon>
                        </IconButton>
                        <IconButton size={'small'} onClick={() => {
                            setQuestionModalState({
                                open: true,
                                record: question,
                                index,
                                path: `${dataSource}.questions.${index}`
                            })
                        }}>
                            <Icon fontSize={"small"}>
                                edit
                            </Icon>
                        </IconButton>
                    </div>
                </div>
            )}
        </Draggable>
    )
}

export default QuestionItem